import { render, staticRenderFns } from "./Addon.vue?vue&type=template&id=82a2eed0&"
import script from "./Addon.vue?vue&type=script&lang=js&"
export * from "./Addon.vue?vue&type=script&lang=js&"
import style0 from "./Addon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports